<ng-container *transloco="let t">
  <ng-template #headerTpl>
    <div class="p-2 rounded-lg bg-primary-soft">
      <div class="flex items-center justify-center size-6 shrink-0 text-primary">
        <mat-icon svgIcon="bell-outline" />
      </div>
    </div>
    <div class="flex flex-col gap-0.5">
      <h2 class="font-semibold text-ink-heading">
        {{ t('ORDER-DETAILS.ORDER-OPTIONS.SEND-REMINDER') }}
      </h2>
      <p class="text-xs text-ink-tertiary">{{ t('SIGNING_PARTICIPANT.SEND_REMINDER_SUBTITLE') }}</p>
    </div>
  </ng-template>

  <ng-template #actionsTemplate>
    <div class="flex items-center justify-between w-full gap-4">
      <span class="text-[0.8125rem] text-ink-muted">
        {{ t('SIGNING_PARTICIPANT.SELECTED_COUNT', { count: selectedCount() | translocoDecimal }) }}
      </span>
      <div class="flex items-center gap-3">
        <dss-libs-ui-button
          color="gray"
          variant="outline"
          class="text-sm!"
          label="GENERAL.CANCEL"
          (clickOutput)="closeModal()"
        />
        <dss-libs-ui-button
          color="primary"
          class="text-sm!"
          label="ORDER-DETAILS.ORDER-OPTIONS.SEND-REMINDER"
          [isProcessing]="isLoading()"
          [disabled]="selectedCount() === 0 || isLoading()"
          (clickOutput)="sendReminders()"
        />
      </div>
    </div>
  </ng-template>

  <dss-libs-ui-base-modal [header]="headerTpl" [actions]="actionsTemplate" (closed)="closeModal()">
    <div class="flex flex-col max-h-84 overflow-y-auto">
      @for (recipient of dialogData?.recipients; track recipient.id) {
      <button
        type="button"
        class="flex items-center gap-3 px-6 py-3.5 transition-colors w-full text-start"
        [class]="
          [
            !$first ? 'border-t border-stroke' : '',
            isDisabled(recipient) ? 'opacity-50 cursor-not-allowed' : 'hover:bg-surface-subtle'
          ].join(' ')
        "
        [disabled]="isDisabled(recipient)"
        (click)="toggleRecipient(recipient.id, recipient)"
      >
        <juno-libs-ui-checkbox
          [checked]="isSelected(recipient.id)"
          [disabled]="isDisabled(recipient)"
          (click)="$event.stopPropagation()"
          (checkedChange)="toggleRecipient(recipient.id, recipient)"
        />
        <div
          class="size-9 rounded-full bg-primary-soft flex items-center justify-center text-xs font-semibold text-primary shrink-0"
        >
          {{ recipient.name | initials }}
        </div>
        <div class="flex flex-col gap-0.5 min-w-0 flex-1">
          <span class="text-sm font-semibold text-ink-heading truncate">{{ recipient.name }}</span>
          <span class="text-xs text-ink-tertiary truncate">{{ recipient.email }}</span>
        </div>
      </button>
      }
    </div>
  </dss-libs-ui-base-modal>
</ng-container>
